export const siteUrl = (import.meta.env.VITE_PUBLIC_SITE_URL || "https://bez-kin-expo.web.app").replace(/\/+$/, "");

export function absoluteUrl(path: string) {
  return new URL(path, `${siteUrl}/`).href;
}

export function serializeJsonLd(value: unknown) {
  return JSON.stringify(value).replace(/</g, "\\u003c").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
